<!--
create by melody on 2019/3/12
description:租赁附注查询页面
-->
<template>
    <div>
        <a id="target" style="display: none" :href="exportUrl"></a>
        <page-header :title="title"></page-header>
        <template>
            <div class="hdp-uf hdp-uf-dc search-container">
                <div class="hdp-uf hdp-uf-hsb">
                    <el-col style="width:30%;">
                        <el-row :span="6" :offset="6">
                            <div class="hdp-uf" style="width:100%;">
                                <div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.ouName')}}</div>
                                <el-select v-model="searchParam.ouName" filterable clearable>
                                    <el-option v-for="(item, index) in busEntityList" :key="index" :label="item" :value="item"></el-option>
                                </el-select>
                            </div>
                        </el-row>
                    </el-col>
                    <el-col :gutter="10" style="width:30%;">
                        <el-row :span="6" :offset="6">
                            <div class="hdp-uf" style="width:100%;">
                                <div class="hdp-uf hdp-uf-vc" style="width:40%;"><span class="color-red"> * </span>{{$t('m.periodName')}}</div>
                                <el-date-picker
                                    style="width:100%;"
                                    v-model="searchParam.periodName"
                                    type="month"
                                    value-format="yyyy-MM"
                                    :placeholder="$t('m.chooseDate')">
                                </el-date-picker>
                            </div>
                        </el-row>
                    </el-col>
                    <el-col :gutter="10" style="width:30%;">
                        <el-row :span="12" :offset="6">
                            <div class="hdp-uf" style="width:100%;">
                                <div class="hdp-uf hdp-uf-vc" style="width:40%;">{{$t('m.relatedParties')}}</div>
                                <el-select filterable v-model="searchParam.intercompanyFlag" style="width:60%;" clearable>
                                    <el-option label="Y" value="Y"></el-option>
                                    <el-option label="N" value="N"></el-option>
                                </el-select>
                            </div>
                        </el-row>
                    </el-col>
                </div>
                <div class="hdp-uf hdp-uf-hsb">
                    <el-col style="width:30%;">
                        <el-row :span="6" :offset="6">
                            <div class="hdp-uf" style="width:100%;">
                                <div class="hdp-uf hdp-uf-vc" style="width:40%;"><span class="color-red"> * </span>{{$t('m.convertCurrency')}}</div>
                                <el-select v-model="searchParam.discountCurrency" filterable clearable>
                                    <el-option v-for="(item, index) in currencyList" :key="index" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </el-row>
                    </el-col>
                    <el-col :gutter="10" style="width:30%;">
                        
                    </el-col>
                </div>
                <div class="hdp-uf hdp-uf-hfe">
                    <el-row>
                        <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
                    </el-row>
                </div>
            </div>
            <div class="table-container">
                <div class="hdp-uf">
                    <el-button type="primary" icon="icon-action-undo" @click="clickExport()" >{{$t('m.exportResults')}} </el-button>
                </div>
                <div style="margin-top: 20px"><el-checkbox v-model="exportData[0].flag">{{$t('m.cashFlowReport')}}</el-checkbox></div>
                <el-table :data="cashFlashData" :key="1" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
                    <el-table-column prop="name" label="" :width="$t('m.nameWidth')"></el-table-column>
                    <el-table-column :label="$t('m.YTDThisYear')" width="200">
                        <template slot-scope="scope">{{ scope.row.currentAccuracy ? $commonFunc.format(scope.row.currentAccuracy) : scope.row.currentAccuracy}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.YTDThisYearMillions')" width="200">
                         <template slot-scope="scope">{{ scope.row.currentMillion ? $commonFunc.format(scope.row.currentMillion) : scope.row.currentMillion}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.YTDLastYear')">
                         <template slot-scope="scope">{{ scope.row.lastAccuracy ? $commonFunc.format(scope.row.lastAccuracy) : scope.row.lastAccuracy}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.YTDLastYearMillions')">
                         <template slot-scope="scope">{{ scope.row.lastMillion ? $commonFunc.format(scope.row.lastMillion) : scope.row.lastMillion}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.relatedWorkingPaper')" width="500" show-overflow-tooltip>
                        <template slot-scope="scope" v-if="token">
                            <span class="span-style" @click="download(scope.row)"> {{scope.row.link}} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div><el-checkbox v-model="exportData[1].flag">{{$t('m.groupAssetUseful')}}</el-checkbox></div>
                <el-table :data="leaseAsset" :key="2" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
                    <el-table-column prop="name" label="" :width="$t('m.nameWidth')"></el-table-column>
                    <el-table-column prop="minUseMonth" :label="$t('m.assetUsefulLifeFrom')" width="300"></el-table-column>
                    <el-table-column prop="maxUseMonth" :label="$t('m.assetUsefulLifeTo')" width="300"></el-table-column>
                    <el-table-column :label="$t('m.relatedWorkingPaper')" width="500" show-overflow-tooltip>
                        <template slot-scope="scope" v-if="token">
                            <span class="span-style" @click="download(scope.row)"> {{scope.row.link}} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div><el-checkbox v-model="exportData[2].flag">{{$t('m.groupLeaseLiability')}}</el-checkbox></div>
                <el-table :data="paymentData" :key="3" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
                    <el-table-column prop="name" label="" :width="$t('m.nameWidth')"></el-table-column>
                    <el-table-column :label="$t('m.YTDThisYear')" width="200">
                         <template slot-scope="scope">{{ scope.row.currentAccuracy ? $commonFunc.format(scope.row.currentAccuracy) : scope.row.currentAccuracy}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.YTDThisYearMillions')" width="200">
                         <template slot-scope="scope">{{ scope.row.currentMillion ? $commonFunc.format(scope.row.currentMillion) : scope.row.currentMillion}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.YTDLastYear')">
                         <template slot-scope="scope">{{ scope.row.lastAccuracy ? $commonFunc.format(scope.row.lastAccuracy) : scope.row.lastAccuracy}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.YTDLastYearMillions')">
                         <template slot-scope="scope">{{ scope.row.lastMillion ? $commonFunc.format(scope.row.lastMillion) : scope.row.lastMillion}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.relatedWorkingPaper')" width="500" show-overflow-tooltip>
                        <template slot-scope="scope" v-if="token">
                            <span class="span-style" @click="download(scope.row)"> {{scope.row.link}} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div><el-checkbox v-model="exportData[3].flag">{{$t('m.assetDisclosure')}}</el-checkbox></div>
                <el-table :data="leaseAsset2" :key="4" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
                    <el-table-column prop="name" label="" :width="$t('m.nameWidth')"></el-table-column>
                    <el-table-column  :label="$t('m.domestic')" width="200">
                         <template slot-scope="scope">{{ scope.row.CNYAccuracy ? $commonFunc.format(scope.row.CNYAccuracy) : scope.row.CNYAccuracy}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.domesticMillions')" width="200">
                         <template slot-scope="scope">{{ scope.row.CNYMillion ? $commonFunc.format(scope.row.CNYMillion) : scope.row.CNYMillion}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.overseas')">
                         <template slot-scope="scope">{{ scope.row.NOCNYAccuracy ? $commonFunc.format(scope.row.NOCNYAccuracy) : scope.row.NOCNYAccuracy}}</template>
                    </el-table-column>
                    <el-table-column width="200" :label="$t('m.overseasMillions')">
                         <template slot-scope="scope">{{ scope.row.NOCNYMillion ? $commonFunc.format(scope.row.NOCNYMillion) : scope.row.NOCNYMillion}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.relatedWorkingPaper')" width="500" show-overflow-tooltip>
                        <template slot-scope="scope" v-if="token">
                            <span class="span-style" @click="download(scope.row)"> {{scope.row.link}} </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div><el-checkbox v-model="exportData[4].flag">{{$t('m.variablePayment3')}}</el-checkbox></div>
                <el-table :data="cashFlashData2" :key="5" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0">
                    <el-table-column prop="name" label="" :width="$t('m.nameWidth')"></el-table-column>
                    <el-table-column :label="$t('m.YTDThisYear')" width="200">
                         <template slot-scope="scope">{{ scope.row.currentAccuracy ? $commonFunc.format(scope.row.currentAccuracy) : scope.row.currentAccuracy}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.YTDThisYearMillions')" width="200">
                         <template slot-scope="scope">{{ scope.row.currentMillion ? $commonFunc.format(scope.row.currentMillion) : scope.row.currentMillion}}</template>
                    </el-table-column>
                    <el-table-column width="300" :label="$t('m.YTDLastYear')">
                         <template slot-scope="scope">{{ scope.row.lastAccuracy ? $commonFunc.format(scope.row.lastAccuracy) : scope.row.lastAccuracy}}</template>
                    </el-table-column>
                    <el-table-column width="300" :label="$t('m.YTDLastYearMillions')">
                         <template slot-scope="scope">{{ scope.row.lastMillion ? $commonFunc.format(scope.row.lastMillion) : scope.row.lastMillion}}</template>
                    </el-table-column>
                    <el-table-column :label="$t('m.relatedWorkingPaper')" width="500" show-overflow-tooltip>
                        <template slot-scope="scope" v-if="token">
                            <span class="span-style" @click="download(scope.row)"> {{scope.row.link}} </span>
                        </template>
                    </el-table-column>
                </el-table>
<!--                <div class="hdp-uf">-->
<!--                    <a href="./static/template/租赁付款模板.xlsx">-->
<!--                        <el-button type="primary" icon="el-icon-download"> {{$t('m.leaseAnnotationTemplate')}} </el-button>-->
<!--                    </a>-->
<!--                    <lap-upload-file uploadUrl="/payment_plan_export/uploadedFile" @successMethod=""></lap-upload-file>-->
<!--                </div>-->
            </div>
            <el-dialog
                :title="$t('m.chooseExpNum')"
                v-if="dialogVisible"
                :visible.sync="dialogVisible"
                width="30%">
                <div class="dialog-content">
                    <el-radio-group v-model="currentPage" style="width: 90%">
                        <el-row :gutter="20">
                            <el-col :span="6" style="margin: 10px 0 " v-for="item in pageArr" :key="item"><el-radio :label="item">第{{item}}个{{pageSize}}条</el-radio></el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                    <el-button type="primary" @click="exportPage()"  v-loading.fullscreen.lock="fullscreenLoading">{{$t('m.sure')}}</el-button>
                </span>
            </el-dialog>

        </template>
    </div>

</template>
<script>
import { mapState,mapGetters} from 'vuex'
import axios from 'axios'
export default {
    data () {
        return {
            title: {
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.OPERATE_MANAGE'),
                thirdTitle: this.$t('m.LEASE_ANNOTATION')
            },
            searchParam: {
                ouName: '',
                periodName: '',
                intercompanyFlag: '',
                discountCurrency: '',
            },
            busEntityList: [],
            currencyList: [],
            exportData: [
            {
                code: 'REPORT_TOTAL_DISCLOSURE',
                flag: false
            }, {
                code: 'REPORT_TOTAL_ASSET_YEAR',
                flag: false
            }, {
                code: 'REPORT_TOTAL_PAYMENT_INFO',
                flag: false
            }, {
                code: 'REPORT_TOTAL_PART_ASSERT_INFO',
                flag: false
            }, {
                code: 'REPORT_TOTAL_PART_VARIABLE_CASH_INFO',
                flag: false
            },
            ],
            checkedExportList: [],
            cashFlashData: [{
                code: 'sumInterest',
                name:this.$t('m.interestPayment'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.cashFlowThisYear'),
                tableCode: '118',
                time: 'this'
            },
            {
                code: 'sumPrincipal',
                name: this.$t('m.financingActivity'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.cashFlowLastYear'),
                tableCode: '118',
                time: 'last'
            },
            {
                code: 'sumActiveCash',
                name: this.$t('m.operatingCashFlow'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code: 'sumCurrentPaymentAmount',
                name: this.$t('m.totalLeaseCashFlow'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.exportLeasePayment'),
                tableCode: '119',
            }],
            leaseAsset: [{
                code: 'useMonth',
                name: this.$t('m.assetUsefulLifeRange'),
                minUseMonth: '',
                maxUseMonth: '',
                link: this.$t('m.leaseAssetLedgerReport'),
                tableCode: '117',
            }],
            paymentData: [{
                code:'oneYearEndBalance',
                name: this.$t('m.withinOneYear'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.thisYearPaymentSchedule'),
                tableCode: '113',
                time: 'this'
            },
            {
                code:'twoYearEndBalance',
                name: this.$t('m.oneToTwo'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.lastYearPaymentSchedule'),
                tableCode: '113',
                time: 'last'
            },
            {
                code:'fiveYearEndBalance',
                name:this.$t('m.twoToFive'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code:'lastYearEndBalance',
                name:this.$t('m.thanFive'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code:'leavePayAmount',
                name: this.$t('m.leaseLiabilityBalance'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code:'oneYearPayAmount',
                name: this.$t('m.leaseLiabilityOne'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code:'lastYearPayAmount',
                name: this.$t('m.leaseLiabilityOneOver'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
                {
                    code:'leaseLiability',
                    name: this.$t('m.leaseLiability'),
                    currentAccuracy: '',
                    currentMillion: '',
                    lastAccuracy: '',
                    lastMillion: '',
                    link: ''
                }
            ],
            leaseAsset2: [{
                code:'assertValue',
                name: this.$t('m.assetInitialValue'),
                CNYAccuracy: '',
                CNYMillion: '',
                NOCNYAccuracy: '',
                NOCNYMillion: '',                
                link: this.$t('m.leaseAssetLedgerReport'),
                tableCode: '117',
                time: ''
            },
            {
                code:'discountValue',
                name: this.$t('m.assetsDepreciation'),
                CNYAccuracy: '',
                CNYMillion: '',
                NOCNYAccuracy: '',
                NOCNYMillion: '',   
                link: '',
                tableCode: '117',
                time: ''
            },
            {
                code:'bookValue',
                name: this.$t('m.assetNetValue'),
                CNYAccuracy: '',
                CNYMillion: '',
                NOCNYAccuracy: '',
                NOCNYMillion: '',       
                link: ''
            }],
            cashFlashData2: [{
                code: 'sumCurrentYearAmount',
                name: this.$t('m.fixedPayment'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.cashFlowDisclosureReport'),
                tableCode: '118',
                time: '',
                isPeriod: true
            },
            {
                code: 'sumCurrentYearVariblePayAmount',
                name: this.$t('m.variablePayment'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: this.$t('m.exportLeasePayment'),
                tableCode: '119',
                time: '',
                isPeriod: true
            },
                {
                    code: 'sumCurrentYearVariblePayAmount1',
                    name: this.$t('m.variablePayment1'),
                    currentAccuracy: '',
                    currentMillion: '',
                    lastAccuracy: '',
                    lastMillion: '',
                    link: this.$t('m.exportLeasePayment'),
                    tableCode: '119',
                    time: '',
                    isPeriod: true
                },
                {
                    code: 'sumCurrentYearVariblePayAmount2',
                    name: this.$t('m.variablePayment2'),
                    currentAccuracy: '',
                    currentMillion: '',
                    lastAccuracy: '',
                    lastMillion: '',
                    link: this.$t('m.exportLeasePayment'),
                    tableCode: '119',
                    time: '',
                    isPeriod: true
                },
            {
                code: 'sumCurrentYearPayAmount',
                name: this.$t('m.leasePayment'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            },
            {
                code: 'currentPercentValue',
                name: this.$t('m.percentage'),
                currentAccuracy: '',
                currentMillion: '',
                lastAccuracy: '',
                lastMillion: '',
                link: ''
            }],
            currentPage: 1,
            reportName: '',
            form: {
            },
            dialogVisible: false,
            pageSize: 1000, 
            fullscreenLoading: false,
            exportUrl: '',
            token: ''
        }
    },
    methods: {
        clickExport() { //
            if(!this.token) {
                this.$message.info(this.$t('m.noDataSearchFirst'))
                return
            }
            let checked = []
            let noChecked = []
            this.exportData.forEach((o,i)=>{
                if(o.flag) {
                    checked.push(o.code)
                } else {
                    noChecked.push(o.code)
                }
            })
            if(noChecked.length == 5) {
                this.checkedExportList = noChecked
            } else {
                this.checkedExportList = checked
            }

            this.exportUrl = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                + '/report/exportTotalTable?token=' + this.token
                + '&keys=' + this.checkedExportList //下载的表
                + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
            
            this.$requestService.downloadFile(this.exportUrl)
            .then(res=>{
                setTimeout(()=>{
                    document.getElementById("target").click()
                }, 1000)
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },  
        download(row) {
            if(!this.searchParam['periodName']) {
                this.$message.info(this.$t('m.requirePeriodName'))
         //       return
         //   } else if(!this.searchParam['intercompanyFlag']) {
         //       this.$message.info(this.$t('m.requireSupplier'))
                return
            } else {
                this.reportName = row.tableCode
                this.form['ouName'] = this.searchParam['ouName']
                this.form['periodName'] = this.searchParam['periodName']
                this.form['intercompanyFlag'] = this.searchParam['intercompanyFlag']
                //没有合同币
                if(row.time == 'last') {//上年度
                    var d = new Date(this.searchParam['periodName'])
                    var y = d.getFullYear() - 1
                    var m = d.getMonth() + 1 > 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
                    this.form['periodName'] = y + '-' + m
                }
                if(row.isPeriod) {
                    this.form['isPeriod'] = true
                } else {
                    this.form['isPeriod'] = false
                }
                // this.checkParam()
                this.exportPage();
            }
        },
        checkParam() {
            this.$commonFunc.commonRequest('get', '/report/validData', 'reportValidData', {tableCode: this.reportName, 
                param: JSON.stringify(this.form)
            })
            .then(res=>{
                if(res.obj) {
                    let total = Number(res.obj)
                    this.pageArr = []
                    this.pages = Math.ceil(total / this.pageSize)
                    for(let i = 1 ; i <= this.pages; i++) {
                        this.pageArr.push(i)
                    }
                    this.dialogVisible = true
                } 
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        exportPage() {
            this.fullscreenLoading = true
            this.exportUrl = (localStorage.getItem('apiServerHost') ? 'http://'+localStorage.getItem('apiServerHost') : this.$config.APISERVER.host)
                            + '/report/export?tableCode=' + this.reportName
                            + '&param=' + encodeURIComponent(JSON.stringify(this.form))
                            + '&lap-cookie-token=' + this.$store.state.userInfo.userInfoObj.token
                            + '&pageSize=' + this.pageSize
                            + '&pageNum=' + this.currentPage
                            + '&t=' + Date.now()
            this.$requestService.downloadFile(this.exportUrl)
            .then(res=>{
                setTimeout(()=>{
                    document.getElementById("target").click()
                }, 1000)
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
            this.dialogVisible = false
            setTimeout(()=>{
                this.fullscreenLoading = false
            }, 5000)
        },
        getDemoList() {
            if(!this.searchParam['periodName']||!this.searchParam['discountCurrency']) {
                this.$message.info(this.$t('m.inputRequire'))
                return
            }
            this.$commonFunc.commonRequest('get', '/report/getTotalTable', 'getExportTotalTable', this.searchParam)
            .then(res=>{
                if(res.obj) {
                    this.token = res.obj.token
                    let assetYearInfo = res.obj.REPORT_TOTAL_ASSET_YEAR //资产折旧信息
                    let paymentInfo = res.obj.REPORT_TOTAL_PAYMENT_INFO //本集团租赁负债
                    let partAssetInfo = res.obj.REPORT_TOTAL_PART_ASSERT_INFO //分部报告资产信息披露
                    let disclosureInfo = res.obj.REPORT_TOTAL_DISCLOSURE //现金流量表
                    let partVariableCashInfo = res.obj.REPORT_TOTAL_PART_VARIABLE_CASH_INFO //可变付款额的披露
                    console.log('可变付款额：' + JSON.stringify(partVariableCashInfo))
                    //现金流量表
                    this.cashFlashData.forEach((o,i)=>{
                        if(o.code == 'sumInterest') {
                            o.currentMillion = disclosureInfo.sumInterest
                            o.lastMillion = disclosureInfo.lastSumInterest 
                            o.currentAccuracy = disclosureInfo.currencyUnitInterest
                            o.lastAccuracy = disclosureInfo.lastCurrencyUnitInterest
                        } else if(o.code == 'sumPrincipal') {
                            o.currentMillion = disclosureInfo.sumPrincipal
                            o.lastMillion = disclosureInfo.lastSumPrincipal 
                            o.currentAccuracy = disclosureInfo.currencyUnitPrincipal
                            o.lastAccuracy = disclosureInfo.lastCurrencyUnitPrincipal
                        } else if(o.code == 'sumActiveCash') {
                            o.currentMillion = disclosureInfo.sumActiveCash
                            o.lastMillion = disclosureInfo.lastSumActiveCash  
                            o.currentAccuracy = disclosureInfo.currencyUnitActiveCash
                            o.lastAccuracy = disclosureInfo.lastCurrencyUnitActiveCash
                        } else if(o.code == 'sumCurrentPaymentAmount') {
                            o.currentMillion = disclosureInfo.sumCurrentPaymentAmount
                            o.lastMillion = disclosureInfo.lastSumCurrentPaymentAmount 
                            o.currentAccuracy = disclosureInfo.currencyUnitPaymentAmount
                            o.lastAccuracy = disclosureInfo.lastCurrencyUnitPaymentAmount
                        }
                    })
                    //本集团资产年限范围
                    this.leaseAsset.forEach((o,i)=>{
                        if(o.code == 'useMonth') {
                            o.minUseMonth = assetYearInfo.minUseMonth
                            o.maxUseMonth = assetYearInfo.maxUseMonth
                        }
                    })
                    //本集团租赁负债
                    this.paymentData.forEach((o,i)=>{
                        
                        if(o.code == 'oneYearEndBalance') {
                            o.currentMillion = paymentInfo.oneYearEndBalance
                            o.lastMillion = paymentInfo.oldOneYearEndBalance
                            o.currentAccuracy = paymentInfo.currencyUnitOneYearEndBalance
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitOneYearEndBalance
                        } else if(o.code == 'twoYearEndBalance') {
                            o.currentMillion = paymentInfo.twoYearEndBalance
                            o.lastMillion = paymentInfo.oldTwoYearEndBalance
                            o.currentAccuracy = paymentInfo.currencyUnitTwoYearEndBalance
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitTwoYearEndBalance
                        } else if(o.code == 'fiveYearEndBalance') {
                            o.currentMillion = paymentInfo.fiveYearEndBalance
                            o.lastMillion = paymentInfo.oldFiveYearEndBalance
                            o.currentAccuracy = paymentInfo.currencyUnitFiveYearEndBalance
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitFiveYearEndBalance
                        } else if(o.code == 'lastYearEndBalance') {
                            o.currentMillion = paymentInfo.lastYearEndBalance
                            o.lastMillion = paymentInfo.oldLastYearEndBalance
                            o.currentAccuracy = paymentInfo.currencyUnitLastYearEndBalance
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitLastYearEndBalance
                        } else if(o.code == 'leavePayAmount') {
                            o.currentMillion = paymentInfo.leavePayAmount
                            o.lastMillion = paymentInfo.oldLeavePayAmount
                            o.currentAccuracy = paymentInfo.currencyUnitLeavePayAmount
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitLeavePayAmount
                        } else if(o.code == 'oneYearPayAmount') {
                            o.currentMillion = paymentInfo.oneYearPayAmount
                            o.lastMillion = paymentInfo.oldOneYearPayAmount
                            o.currentAccuracy = paymentInfo.currencyUnitOneYearPayAmount
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitOneYearPayAmount
                        } else if(o.code == 'lastYearPayAmount') {
                            o.currentMillion = paymentInfo.lastYearPayAmount
                            o.lastMillion = paymentInfo.oldLastYearPayAmount
                            o.currentAccuracy = paymentInfo.currencyUnitLastYearPayAmount
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitLastYearPayAmount
                        } else if(o.code == 'leaseLiability') {
                            o.currentMillion = paymentInfo.leaseLiability
                            o.lastMillion = paymentInfo.oldLeaseLiability
                            o.currentAccuracy = paymentInfo.currencyUnitLeaseLiability
                            o.lastAccuracy = paymentInfo.oldCurrencyUnitoldLeaseLiability
                        }
                    })
                    
                    //分部报告资产信息披露
                    this.leaseAsset2.forEach((o,i)=>{
                        if (o.code == 'assertValue') {
                            o.CNYMillion = partAssetInfo.sumCNYAssertValue
                            o.NOCNYMillion = partAssetInfo.sumNOCNYAssertValue  
                            o.CNYAccuracy = partAssetInfo.currencyUnitCNYAssertValue
                            o.NOCNYAccuracy = partAssetInfo.currencyUnitNOCNYAssertValue 
                        } else if(o.code == 'discountValue') {
                            o.CNYMillion = partAssetInfo.sumCNYAssertTotalDiscountValue
                            o.NOCNYMillion = partAssetInfo.sumNOCNYAssertTotalDiscountValue 
                            o.CNYAccuracy = partAssetInfo.currencyUnitCNYAssertTotalDiscountValue
                            o.NOCNYAccuracy = partAssetInfo.currencyUnitNOCNYAssertTotalDiscountValue
                        } else if(o.code == 'bookValue') {
                            o.CNYMillion = partAssetInfo.sumCNYBookValue
                            o.NOCNYMillion = partAssetInfo.sumNOCNYBookValue 
                            o.CNYAccuracy = partAssetInfo.currencyUnitCNYBookValue
                            o.NOCNYAccuracy = partAssetInfo.currencyUnitNOCNYBookValue
                        }
                    })    
                    //可变付款额的披露
                    this.cashFlashData2.forEach((o,i)=>{
                        if(o.code == 'sumCurrentYearAmount') {
                            o.currentMillion = partVariableCashInfo.sumCurrentYearAmount
                            o.lastMillion = partVariableCashInfo.lastSumCurrentYearAmount
                            o.currentAccuracy = partVariableCashInfo.currencyUnitCurrentYearAmount
                            o.lastAccuracy = partVariableCashInfo.lastCurrencyUnitSumCurrentYearAmount
                        } else if(o.code == 'sumCurrentYearPayAmount') {
                            o.currentMillion = partVariableCashInfo.sumCurrentYearPayAmount
                            o.lastMillion = partVariableCashInfo.lastSumCurrentYearPayAmount
                            o.currentAccuracy = partVariableCashInfo.currencyUnitCurrentYearPayAmount
                            o.lastAccuracy = partVariableCashInfo.lastCurrencyUnitSumCurrentYearPayAmount
                        } else if(o.code == 'sumCurrentYearVariblePayAmount') {
                            o.currentMillion = partVariableCashInfo.sumCurrentYearVariblePayAmount
                            o.lastMillion = partVariableCashInfo.lastSumCurrentYearVariblePayAmount
                            o.currentAccuracy = partVariableCashInfo.currencyUnitCurrentYearVariblePayAmount
                            o.lastAccuracy = partVariableCashInfo.lastCurrencyUnitSumCurrentYearVariblePayAmount
                        }
                        else if(o.code == 'sumCurrentYearVariblePayAmount1') {
                            o.currentMillion = partVariableCashInfo.sumCurrentYearVariblePayAmount1
                            o.lastMillion = partVariableCashInfo.lastSumCurrentYearVariblePayAmount1
                            o.currentAccuracy = partVariableCashInfo.currencyUnitCurrentYearVariblePayAmount1
                            o.lastAccuracy = partVariableCashInfo.lastCurrencyUnitSumCurrentYearVariblePayAmount1
                        }else if(o.code == 'sumCurrentYearVariblePayAmount2') {
                            o.currentMillion = partVariableCashInfo.sumCurrentYearVariblePayAmount2
                            o.lastMillion = partVariableCashInfo.lastSumCurrentYearVariblePayAmount2
                            o.currentAccuracy = partVariableCashInfo.currencyUnitCurrentYearVariblePayAmount2
                            o.lastAccuracy = partVariableCashInfo.lastCurrencyUnitSumCurrentYearVariblePayAmount2
                        }else if(o.code == 'currentPercentValue') {
                            o.currentMillion = partVariableCashInfo.currentPercentValue + "%"
                            o.lastMillion = partVariableCashInfo.lastCurrentPercentValue + "%"
                        }
                    })
                }
                
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        getBusEntity() {
            this.$commonFunc.commonRequest('get', '/config/primaryData/getUserCompanyInfo')
            .then(res=>{
                if(res.obj && res.obj.length) {
                    this.busEntityList = res.obj   
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        }
    },
    async mounted() {
        this.getBusEntity()
        this.currencyList = await this.$commonFunc.getValueSetList(this.$valueSetObj.CURRENCY)
    }
}
</script>
<style scoped>
.search-container {
    background: #ffffff;
    padding: 20px 20px 0 20px;
}
.table-container {
    padding: 24px;
    margin: 32px 0;
    background: #ffffff;
}
.el-row {
    margin-bottom: 20px;
}
.el-col {
    border-radius: 4px;
}
.block {
    text-align: right;
}
.el-form-item .el-form-item__content {
    margin-left: 10px !important;
}
.color-red {
    color: red
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/LeaseAnnotation.vue